import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormArray, UntypedFormControl} from '@angular/forms';
import {ControlTemplate} from '../_interface/control-template.enum';
import {isControlRequired} from '../functions/check-if-control-required.fn';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {FormFieldWarnings} from '../../../../journal/src/_interface/form-field-warnings.interface';

@UntilDestroy()
@Component({
	selector: 'form-checkbox-list',
	templateUrl: './checkbox-list.component.html',
	styleUrls: ['../checkbox/checkbox.component.scss']
})
export class CheckboxListComponent implements OnInit {

	@Input() options: string[] = [];
	@Input() label: string;
	@Input() control: UntypedFormControl;
	@Input() template: ControlTemplate = ControlTemplate.inline;
	@Input() variant: ControlTemplate = ControlTemplate.horizontal;

	@Input() set setWarnings(warnings: FormFieldWarnings) {
		this.warnings = warnings;
	}

	ControlTemplate = ControlTemplate;
	isControlRequired: boolean;
	warnings: FormFieldWarnings;

	formArray: UntypedFormArray;
	random = `-${Math.random().toPrecision(3)}`;
	idArr: string[] = [];

	private setFormArray(value: string[] = []) {
		if (!this.options) throw new Error('Options to checkbox-list not provided');
		const valueDuplicate = value.slice();
		this.formArray = new UntypedFormArray(this.options.map((item) => {
			const includes = valueDuplicate.includes((item));
			includes && valueDuplicate.splice(valueDuplicate.indexOf(item), 1);
			return new UntypedFormControl(includes);
		}));
		this.hasValue = value.some(v => !!v);
		this.formArray.valueChanges.pipe(
			untilDestroyed(this)
		).subscribe(res => {
			const newValue = this.options.map((item, index) => res[index] ? item : null);
			this.control.patchValue(newValue);
			this.control.markAsTouched();
			this.control.markAsDirty();
			this.hasValue = newValue.some(v => v !== null);
		});
	}

	ngOnInit(): void {
		this.setFormArray(this.control.value || []);
		this.isControlRequired = isControlRequired(this.control);
		this.getId();
	}

	getId() {
		if (!this.options) return;
		this.options.forEach((option) => this.idArr.push(`${option}-${this.random}`));
	}

	hasValue = false;

}
